export const PATH_TRAIL = '/trails/:id';
export const PATH_TRAILS = '/trails';
